
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30613',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30613",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55074",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8201",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11654",
  "I18n": "static-7.1646",
  "quartz": "static-1.7268",
  "quartz-config": "static-1.1046",
  "quartz-core": "static-1.6487",
  "react-dlb": "static-1.83",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.8",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.844",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55061",
  "feedback-utils": "static-1.55065",
  "forms-embed-utils-lib": "static-1.4643",
  "forms-utils-lib": "static-1.12911",
  "foundations-assets": "static-1.5053",
  "foundations-components": "static-1.8280",
  "foundations-theming": "static-1.4617",
  "hub-http": "static-1.6398",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11961",
  "icons": "static-2.666",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4045",
  "raven": "static-3.5925",
  "react": "static-7.189",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16880",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5469",
  "react-virtualized": "static-2.102",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.491",
  "tinymce-plugins": "static-1.57965",
  "transmute": "static-2.85",
  "ui-images": "static-2.1207",
  "UIComponents": "static-3.8600",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3529",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3545",
  "quartz-webpack": "static-1.3492",
  "foundations-theming-specialty": "static-1.2333",
  "property-description-translator": "static-1.4016",
  "HeadJS": "static-2.778",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3312",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4502",
  "jasmine-runner": "static-1.6635",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.853",
  "hubspotter-http": "static-1.4779",
  "mobile-manifest-mixins": "static-1.552",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.943",
  "quartz-head": "static-1.933",
  "quartz-i18n": "static-1.943",
  "quartz-routing": "static-1.698",
  "quartz-test": "static-1.943",
  "quartz-tracking": "static-1.647",
  "trellis-components": "static-1.2309",
  "ui-fonts": "static-1.916",
  "usage-tracker-container": "static-1.7520",
  "usage-tracker-core": "static-1.7380",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.160",
  "conversations-skeleton-state": "static-1.7427",
  "reference-resolvers": "static-1.8354",
  "sanitize-text": "static-1.8324",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10543",
  "sanitize": "static-1.4656",
  "outpost": "static-1.4346",
  "rpc-client-utils": "static-1.4837",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4549",
  "floating-ui": "static-1.60",
  "hs-story-utils": "static-1.9605",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.46",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2290",
  "bend-plugin-foundations-theming": "static-1.3100",
  "foundations-theming-base": "static-1.3602",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.209",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "ai-components-ui-library": "static-1.9414",
  "atom": "static-1.5254",
  "codemirror": "static-5.98",
  "content-assistance-lib": "static-1.8027",
  "ContentUtils": "static-1.68898",
  "data-token-picker": "static-1.16722",
  "file-manager-components": "static-1.24154",
  "FileManagerCore": "static-1.39653",
  "FileManagerLib": "static-1.39794",
  "frontend-preferences-client": "static-1.8106",
  "hub-http-contrib": "static-1.3221",
  "interframe": "static-3.4934",
  "layout-dnd-components": "static-1.12790",
  "layout-dnd-utils": "static-1.11765",
  "property-translator": "static-1.5572",
  "react-codemirror": "static-1.10813",
  "react-colorpicker": "static-2.10387",
  "reference-resolvers-lite": "static-1.8276",
  "rich-text-lib": "static-1.20140",
  "tinymce-data": "static-1.40936",
  "tinymce-themes": "static-1.56821",
  "ui-addon-emoji-picker": "static-1.10063",
  "ui-addon-sales-email": "static-1.5392",
  "ui-brand-identity-lib": "static-1.15948",
  "bender-build-tools": "static-1.3308",
  "hub-http-shared-msw-handlers": "static-1.10407",
  "hubspotter-http-shared-msw-handlers": "static-1.10405",
  "usage-tracker-session-replay": "static-1.5216",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1127",
  "tanstack-virtual": "static-1.33",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.247",
  "chirp-fetch": "static-1.2066",
  "chatspot-core": "static-1.22228",
  "copilot-toolkit": "static-1.11599",
  "customer-data-objects-ui-components": "static-1.13210",
  "data-fetching-client": "static-1.9838",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4937",
  "ui-addon-video-player": "static-1.8885",
  "ui-coaching-tips": "static-1.29066",
  "usage-tracker": "static-1.7530",
  "cms-field-types": "static-1.4994",
  "content-icons-ui": "static-1.2280",
  "integrations-lib": "static-1.16730",
  "customer-data-objects": "static-1.7858",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1362",
  "apollo-link-hub-http": "static-2.4831",
  "apollo-stack-hubspot": "static-3.89",
  "graphql": "static-1.85",
  "immer": "static-1.33",
  "immerable": "static-1.4327",
  "ui-addon-iframeable": "static-1.9254",
  "video-components-external": "static-1.11871",
  "video-data-lib": "static-1.35529",
  "audio-components": "static-1.6182",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29629",
  "FileManagerImages": "static-1.37305",
  "foundations-components-legacy": "static-1.1305",
  "html-to-image": "static-1.57",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.529",
  "ui-universal-auth": "static-1.9188",
  "urlinator": "static-1.4711",
  "video-components": "static-1.13873",
  "video-embed": "static-1.36363",
  "ts-schema": "static-1.4208",
  "ContentData": "static-1.68973",
  "layout-data-lib": "static-1.10090",
  "react-dnd-compat": "static-1.4793",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1724",
  "external-options-client-types": "static-1.4254",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7073",
  "hs-promise-utils": "static-1.5772",
  "inbound-db-properties-service-client": "static-1.3974",
  "NamespacedHubStyle": "static-2.9179",
  "growth-onboarding-confetti": "static-1.3241",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11327",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5673",
  "magpie-types": "static-1.5133",
  "simple-logging-lib": "static-1.3228",
  "avatar-components": "static-1.2677",
  "customer-data-ui-utilities": "static-1.10004",
  "growth-onboarding-feedback-components": "static-1.6758",
  "flux-actions": "static-1.353",
  "hubspot-apollo-client": "static-1.5055",
  "integrations-error-boundary-lib": "static-1.14145",
  "integrations-tracking-lib": "static-1.5786",
  "laboratory-lib": "static-3.7330",
  "native-integrations-shared-strings": "static-1.7959",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10441",
  "unified-auth": "static-1.702",
  "breeze-engine-core": "static-1.640",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "navigation-messaging": "static-1.7841",
  "content-media-composition-data-lib": "static-1.12905",
  "content-media-compositions": "static-2.16912",
  "idb-keyval": "static-1.47",
  "media-bridge-lib": "static-1.19238",
  "unified-auth-core-lib": "static-1.984",
  "social-insights-client-types": "static-1.22554",
  "advanced-menus-core": "static-1.15423",
  "advanced-menus-lib": "static-1.12318",
  "ExportDialog": "static-6.10558",
  "ui-memberships-settings-lib": "static-1.34543",
  "conditional-properties-service-client": "static-1.3925",
  "crm-pipelines-api-client-types": "static-1.4266",
  "fdsr-migration-layer": "static-1.192",
  "framework-builder-read-service-client": "static-1.4134",
  "framework-data-schema-quick-fetch": "static-1.6978",
  "inbound-db-meta-service-client": "static-1.3716",
  "multi-currency-client-types": "static-1.3820",
  "persist-promise": "static-1.3881",
  "foundations-components-test-utils": "static-1.5763",
  "reactive-lib": "static-1.903",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.514",
  "universal-page-editor-lib": "static-1.3191",
  "adobe-sign-auth-lib": "static-1.209",
  "ads-unified-auth-lib": "static-1.697",
  "google-sheets-integration-lib": "static-1.774",
  "microsoft-drive-integration-lib": "static-1.878",
  "surveymonkey-integration-lib": "static-1.224",
  "slack-ui-library": "static-1.10577",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3909",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15422",
  "simple-menus-lib": "static-1.16939",
  "crm-record-cards-service-types": "static-1.3713",
  "location-customization-utils-lib": "static-1.9794",
  "react-flip-move": "static-1.74"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30613",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55074",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8201",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11654",
  "I18n": "/I18n/static-7.1646",
  "quartz": "/quartz/static-1.7268",
  "quartz-config": "/quartz-config/static-1.1046",
  "quartz-core": "/quartz-core/static-1.6487",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.8",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.844",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55061",
  "feedback-utils": "/feedback-utils/static-1.55065",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4643",
  "forms-utils-lib": "/forms-utils-lib/static-1.12911",
  "foundations-assets": "/foundations-assets/static-1.5053",
  "foundations-components": "/foundations-components/static-1.8280",
  "foundations-theming": "/foundations-theming/static-1.4617",
  "hub-http": "/hub-http/static-1.6398",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11961",
  "icons": "/icons/static-2.666",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4045",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.189",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16880",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5469",
  "react-virtualized": "/react-virtualized/static-2.102",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "tinymce-plugins": "/tinymce-plugins/static-1.57965",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1207",
  "UIComponents": "/UIComponents/static-3.8600",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3529",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3545",
  "quartz-webpack": "/quartz-webpack/static-1.3492",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2333",
  "property-description-translator": "/property-description-translator/static-1.4016",
  "HeadJS": "/HeadJS/static-2.778",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3312",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4502",
  "jasmine-runner": "/jasmine-runner/static-1.6635",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.853",
  "hubspotter-http": "/hubspotter-http/static-1.4779",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.552",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.943",
  "quartz-head": "/quartz-head/static-1.933",
  "quartz-i18n": "/quartz-i18n/static-1.943",
  "quartz-routing": "/quartz-routing/static-1.698",
  "quartz-test": "/quartz-test/static-1.943",
  "quartz-tracking": "/quartz-tracking/static-1.647",
  "trellis-components": "/trellis-components/static-1.2309",
  "ui-fonts": "/ui-fonts/static-1.916",
  "usage-tracker-container": "/usage-tracker-container/static-1.7520",
  "usage-tracker-core": "/usage-tracker-core/static-1.7380",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.160",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7427",
  "reference-resolvers": "/reference-resolvers/static-1.8354",
  "sanitize-text": "/sanitize-text/static-1.8324",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10543",
  "sanitize": "/sanitize/static-1.4656",
  "outpost": "/outpost/static-1.4346",
  "rpc-client-utils": "/rpc-client-utils/static-1.4837",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4549",
  "floating-ui": "/floating-ui/static-1.60",
  "hs-story-utils": "/hs-story-utils/static-1.9605",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.46",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2290",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3100",
  "foundations-theming-base": "/foundations-theming-base/static-1.3602",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.209",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9414",
  "atom": "/atom/static-1.5254",
  "codemirror": "/codemirror/static-5.98",
  "content-assistance-lib": "/content-assistance-lib/static-1.8027",
  "ContentUtils": "/ContentUtils/static-1.68898",
  "data-token-picker": "/data-token-picker/static-1.16722",
  "file-manager-components": "/file-manager-components/static-1.24154",
  "FileManagerCore": "/FileManagerCore/static-1.39653",
  "FileManagerLib": "/FileManagerLib/static-1.39794",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8106",
  "hub-http-contrib": "/hub-http-contrib/static-1.3221",
  "interframe": "/interframe/static-3.4934",
  "layout-dnd-components": "/layout-dnd-components/static-1.12790",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11765",
  "property-translator": "/property-translator/static-1.5572",
  "react-codemirror": "/react-codemirror/static-1.10813",
  "react-colorpicker": "/react-colorpicker/static-2.10387",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8276",
  "rich-text-lib": "/rich-text-lib/static-1.20140",
  "tinymce-data": "/tinymce-data/static-1.40936",
  "tinymce-themes": "/tinymce-themes/static-1.56821",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10063",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5392",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15948",
  "bender-build-tools": "/bender-build-tools/static-1.3308",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10407",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10405",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5216",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1127",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.247",
  "chirp-fetch": "/chirp-fetch/static-1.2066",
  "chatspot-core": "/chatspot-core/static-1.22228",
  "copilot-toolkit": "/copilot-toolkit/static-1.11599",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13210",
  "data-fetching-client": "/data-fetching-client/static-1.9838",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4937",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8885",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29066",
  "usage-tracker": "/usage-tracker/static-1.7530",
  "cms-field-types": "/cms-field-types/static-1.4994",
  "content-icons-ui": "/content-icons-ui/static-1.2280",
  "integrations-lib": "/integrations-lib/static-1.16730",
  "customer-data-objects": "/customer-data-objects/static-1.7858",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1362",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4831",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "graphql": "/graphql/static-1.85",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4327",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9254",
  "video-components-external": "/video-components-external/static-1.11871",
  "video-data-lib": "/video-data-lib/static-1.35529",
  "audio-components": "/audio-components/static-1.6182",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29629",
  "FileManagerImages": "/FileManagerImages/static-1.37305",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1305",
  "html-to-image": "/html-to-image/static-1.57",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.529",
  "ui-universal-auth": "/ui-universal-auth/static-1.9188",
  "urlinator": "/urlinator/static-1.4711",
  "video-components": "/video-components/static-1.13873",
  "video-embed": "/video-embed/static-1.36363",
  "ts-schema": "/ts-schema/static-1.4208",
  "ContentData": "/ContentData/static-1.68973",
  "layout-data-lib": "/layout-data-lib/static-1.10090",
  "react-dnd-compat": "/react-dnd-compat/static-1.4793",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1724",
  "external-options-client-types": "/external-options-client-types/static-1.4254",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7073",
  "hs-promise-utils": "/hs-promise-utils/static-1.5772",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3974",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9179",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3241",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11327",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5673",
  "magpie-types": "/magpie-types/static-1.5133",
  "simple-logging-lib": "/simple-logging-lib/static-1.3228",
  "avatar-components": "/avatar-components/static-1.2677",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10004",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6758",
  "flux-actions": "/flux-actions/static-1.353",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5055",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14145",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5786",
  "laboratory-lib": "/laboratory-lib/static-3.7330",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7959",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10441",
  "unified-auth": "/unified-auth/static-1.702",
  "breeze-engine-core": "/breeze-engine-core/static-1.640",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "navigation-messaging": "/navigation-messaging/static-1.7841",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12905",
  "content-media-compositions": "/content-media-compositions/static-2.16912",
  "idb-keyval": "/idb-keyval/static-1.47",
  "media-bridge-lib": "/media-bridge-lib/static-1.19238",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.984",
  "social-insights-client-types": "/social-insights-client-types/static-1.22554",
  "advanced-menus-core": "/advanced-menus-core/static-1.15423",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12318",
  "ExportDialog": "/ExportDialog/static-6.10558",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34543",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3925",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4266",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.192",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4134",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6978",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3716",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3820",
  "persist-promise": "/persist-promise/static-1.3881",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5763",
  "reactive-lib": "/reactive-lib/static-1.903",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.514",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3191",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.209",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.697",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.774",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.224",
  "slack-ui-library": "/slack-ui-library/static-1.10577",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3909",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15422",
  "simple-menus-lib": "/simple-menus-lib/static-1.16939",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3713",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9794",
  "react-flip-move": "/react-flip-move/static-1.74"
}
};
